import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { LEAVE_QUERY_KEYS } from './keys';

import { fetchWellBeingLeaves } from 'services/leave';
import type { QueryObject } from 'interface/queryParam';

type WellBeingLeaveParams = QueryObject & {
  userId?: string | number;
  fiscalYearId?: string | number;
};

export type WellBeingLeaveCredit = Record<string, string | number | boolean | null>;

export function useFetchWellBeingLeaveCredits<TData = WellBeingLeaveCredit[]>(
  param: WellBeingLeaveParams = {}
): UseQueryResult<TData, Error> {
  return useQuery<TData, Error>({
    queryKey: [LEAVE_QUERY_KEYS.WELL_BEING_LEAVE_CREDITS, param.userId, param.fiscalYearId],
    queryFn: () => fetchWellBeingLeaves(param) as Promise<TData>,
    enabled: Boolean(param.userId) && Boolean(param.fiscalYearId),
  });
}
